export const TITLE = 'plp.title';
export const NO_PRODUCTS = 'plp.no_products';
